// Third party
import React from 'react';
import classNames from 'classnames';

// Components
import Button from './Button';

// Utils
import { formatMessage, FormattedMessage } from '../../../utils/i18n';

type Props = {
  ariaLabel?: string;
  onClick: () => void;
  dark?: boolean;
  withText?: boolean;
  customLabel?: string;
  className?: string;
  disabled?: boolean;
};

const CloseButton = ({ onClick, dark, withText = false, customLabel, className, disabled, ...rest }: Props) => (
  <Button
    aria-label={rest.ariaLabel || formatMessage('Common.Close')}
    onClick={onClick}
    className={classNames(className, 'close-button', { dark, 'with-text': withText || customLabel })}
    icon="cross-thin"
    disabled={disabled}
  >
    {withText && customLabel === undefined && <FormattedMessage id="Common.Close" />}

    {customLabel !== undefined && <span>{customLabel}</span>}
  </Button>
);

export default CloseButton;
